export default "__VITE_ASSET__3_$crGE9__"